import React, { useEffect, useState } from "react";
import { FilterIcon, ManagerViewIcon } from "../../utils/icons";
import {
  AvatarContainer,
  Column,
  Tab,
  Divider,
  Header,
  MyTaskCard,
  TableHeader,
  TableRow,
  Tabs,
  TaskTypeCard,
  TaskTypeTab,
  Title,
  ReminderDot,
  DataColumn,
  ScrollableContainer,
  ShowMore,
  NameInitials,
  ManagerIconContainer,
} from "./styles";
import { GetMyTasksDetails } from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import {
  fetchApi,
  getInitials,
  getStartAndEndDates,
} from "../../utils/methods";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import styled from "styled-components";
import RecognitionModal from "./RecognitionModal";
import LazyImage from "../common/LazyImage/LazyImage";
import { ImageUrl } from "../../utils/constants";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getInspirationPost } from "../../redux/actions/socialActions";
import SocialPostPopup from "./SocialPostPopup";
import PropTypes from "prop-types";

const CustomToggleV1 = styled(Dropdown.Toggle)`
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: red;
  background: none !important;
  border: none !important;

  .filter-icon {
    display: flex;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
  }

  &:hover {
    color: #00abb6;
  }

  &::after {
    display: none !important;
  }
`;

const CustomMenuV1 = styled(Dropdown.Menu)`
  border: 1px solid #EFEFEF !important;
  border-radius: 4px !important;
  padding: 0px !important;
  width: 136px !important;
  min-width: 136px !important;
  height: 144px !important;
  overflow-x: hidden !important;
  overflow-y: hidden !important;

  position: absolute !important;
  top: 14px !important;
  left: auto !important;
  right: 14px !important;
  z-index: 1050 !important;
`;

const CustomDropdownItemV1 = styled(Dropdown.Item)`
  font-family: "Lato" !important;
  font-size: 16px !important;
  padding: 14px 16px !important;
  border-radius: 4px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${({ active }) => (active ? "white" : "#184A61")} !important;
  background-color: ${({ active }) =>
    active ? "#F37A65" : "transparent"} !important;

  &:hover {
    color: ${({ active }) => (active ? "white" : "white")} !important;
    background-color: ${({ active }) =>
    active ? "#F37A65" : "#EA6149"} !important;
    border-radius:4px  !important;
  }
`;

function MyTasksCard({ fetchRecognitionData}) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.profileData);
  const { inspirationPost } = useSelector((state) => state.social);
  const [myTaskData, setMyTaskData] = useState([]);
  const [timeInterval, setTimeInterval] = useState("Monthly");
  const [tabType, setTabType] = useState("overdue");
  const [taskType, setTaskType] = useState("all");
  const [showAllRows, setShowAllRows] = useState(false);
  const [count, setCount] = useState(0);
  const [birthday, setBirthday] = useState(0);
  const [anniversary, setAnniversary] = useState(0);
  const [recognition, setRecognition] = useState(0);
  const userCompany = useSelector((state) => state.profileData.userCompany);
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [recognitionType, setRecognitionType] = useState(null);
  



  useEffect(() => {
    fetchMyTaskData();
  }, [timeInterval, tabType]);

  useEffect(() => {
    fetchMyTaskData(true);
  }, [timeInterval]);

  useEffect(() => {
  }, [inspirationPost]);

  const fetchMyTaskData = async (initialLoad = false) => {
    const { startDate, endDate } = getStartAndEndDates(timeInterval);
    const apiUrl = `${GetMyTasksDetails}/${tabType}/${startDate}/${endDate}`;

    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setMyTaskData(res.data);
        fetchRecognitionData();
        if (tabType === "overdue") {
          setCount(res.data.all.length);
          setBirthday(res.data.birthday.length);
          setAnniversary(res.data.anniversary.length);
          setRecognition(res.data.recognition.length);
          if (initialLoad && res.data.all.length === 0) {
            setTabType("upcoming");
          }
        }
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  const handleSelect = (eventKey) => {
    setTimeInterval(eventKey);
  };

  const handleTabTypeClick = (type) => {
    setTabType(type);
  };

  const getFilteredData = () => {
    switch (taskType) {
    case "recognition":
      return myTaskData?.recognition || [];
    case "birthday":
      return myTaskData?.birthday || [];
    case "anniversary":
      return myTaskData?.anniversary || [];
    default:
      return myTaskData?.all || [];
    }
  };

  const renderTableRows = () => {

    const filteredData = getFilteredData();

    const handleOpenModal = (item) => {
      setRecognitionType(item.recognition_type);
      setModalData(item);
      setShowModal(true);
    };
  

    const handleOpenCompletedModal = async (item) => {
      dispatch(getInspirationPost(item.post_id));
      setIsModalOpen(true);
    };

    const handleCloseModal = () => {
      setShowModal(false);
      setModalData(null);
    };

    const CloseModal = () => {
      setIsModalOpen(false);
    };

    if (filteredData.length === 0) {
      return (
        <div
          id="no-data-found"
          style={{
            textAlign: "center",
            marginTop: "20px",
            color: "#184A61",
            fontSize: "16px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontFamily: "Lato",
          }}
        >
          No tasks found!
        </div>
      );
    }

    const rowsToShow = showAllRows ? filteredData : filteredData.slice(0, 5);

    return (
      <>
        {rowsToShow.map((item, index) => {
          const isDisabled =
            (item.recognition_type === "birthday" ||
              item.recognition_type === "anniversary") &&
            moment(item.due_date).isAfter(moment());

          return (
            <React.Fragment key={index}>
              <TableRow isCursor={"default"} id="table-row">
                <DataColumn id="data-column">
                  <AvatarContainer isProfile={true} id="profile-image">
                    {item?.profile_image !== "profile-Image/default.png" ? (
                      <LazyImage
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "48px",
                          border: "1px solid  #DCDCDC",
                        }}
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                        src={`${ImageUrl}/${item?.profile_image}`}
                      />
                    ) : (
                      <NameInitials id="name-initials">
                        {getInitials(item?.full_name)}
                      </NameInitials>
                    )}
                  </AvatarContainer>
                  <span id="full-name">{item.full_name}</span>
                </DataColumn>
                <DataColumn
                  id="data-column-overdue"
                  isColor={tabType === "overdue" ? "#E12133" : "#184A61"}
                >
                  {item.recognition_type === "recognition"
                    ? moment(item.due_date).format("MMM")
                    : moment(item.due_date).format("DD, MMM")}
                </DataColumn>

                <DataColumn isCapital={true} id="data-column-work">
                  <ReminderDot
                    isReminderColor={item.recognition_color}
                  ></ReminderDot>
                  {item.recognition_type === "anniversary"
                    ? "Work Anniversary"
                    : item.recognition_type}
                </DataColumn>
                <DataColumn
                  id="data-column-completed"
                  isColor={isDisabled ? "#989898" : "#184A61"}
                  onClick={
                    !isDisabled
                      ? tabType === "completed"
                        ? () => handleOpenCompletedModal(item)
                        : () => handleOpenModal(item)
                      : null
                  }
                  style={{ cursor: "pointer" }}
                >
                  {tabType === "completed" ? (
                    <>
                      {" "}
                      <ManagerIconContainer>
                        {" "}
                        {ManagerViewIcon()}{" "}
                      </ManagerIconContainer>{" "}
                      &nbsp;
                      <div style={{ marginLeft: "12px" }}>
                        {item.action}
                      </div>{" "}
                    </>
                  ) : (
                    item.action
                  )}
                </DataColumn>
              </TableRow>
              <Divider id="divider" isMargin={"8px 0px"}></Divider>
            </React.Fragment>
          );
        })}

        {showModal && (
          <RecognitionModal
            show={showModal}
            modalData={modalData}
            onClose={handleCloseModal}
            recognitionType={recognitionType}
            loggedInUser={user}
            fetchMyTaskData={fetchMyTaskData}
            companyId={userCompany.id}
          />
        )}
        {isModalOpen && inspirationPost?.id && (
          <SocialPostPopup
            isOpen={isModalOpen}
            feed={inspirationPost}
            onClose={CloseModal}
            profileImage={user?.profile_image}
          />
        )}
      </>
    );
  };

  const filteredData = getFilteredData();

  return (
    <div>
      <MyTaskCard id="my-task-card">
        <Header id="header">
          <AvatarContainer isProfile={true} id="avatar-container">
            <LazyImage
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "40px",
                border: "1px solid  #dcdcdc",
              }}
              onError={() => window.console.error("Image failed to load")}
              src={`${ImageUrl}/${user?.profile_image}`}
            />
            <Title id="title">My Tasks</Title>
          </AvatarContainer>

          <Tabs id="tabs">
            <Tab
              id="tab-upcoming"
              onClick={() => handleTabTypeClick("upcoming")}
              active={tabType === "upcoming"}
            >
              Upcoming
            </Tab>
            {/* <Tab
              onClick={() => handleTabTypeClick("overdue")}
              active={tabType === "overdue"}
            >
              {count === 0 ? "Overdue" : `Overdue (${count})`}
            </Tab> */}
            <Tab
              id="tab-overduw"
              onClick={() => handleTabTypeClick("overdue")}
              active={tabType === "overdue"}
            >
              {taskType === "recognition"
                ? `Overdue (${recognition})`
                : taskType === "anniversary"
                  ? `Overdue (${anniversary})`
                  : taskType === "birthday"
                    ? `Overdue (${birthday})`
                    : `Overdue (${count})`}
            </Tab>
            <Tab
              id="tab-completed"
              onClick={() => handleTabTypeClick("completed")}
              active={tabType === "completed"}
            >
              Completed
            </Tab>
          </Tabs>

          <Dropdown id="filter-icon" onSelect={handleSelect} style={{ cursor: "pointer" }}>
            <CustomToggleV1 id="dropdown-custom-components">
              <div className="filter-icon"> {FilterIcon()}</div>
            </CustomToggleV1>

            <CustomMenuV1 id="custom-menu" align="end">
              {["Monthly", "Quarterly", "Yearly"].map((interval) => (
                <CustomDropdownItemV1
                  key={interval}
                  eventKey={interval}
                  active={timeInterval === interval}
                >
                  {interval}
                </CustomDropdownItemV1>
              ))}
            </CustomMenuV1>
          </Dropdown>
        </Header>
        <TaskTypeCard id="task-type-card">
          <TaskTypeTab
            id="all-type-tab"
            onClick={() => setTaskType("all")}
            active={taskType === "all"}
          >
            All
          </TaskTypeTab>
          <TaskTypeTab
            id="recognition-type-tab"
            onClick={() => setTaskType("recognition")}
            active={taskType === "recognition"}
          >
            Recognition
          </TaskTypeTab>
          <TaskTypeTab
            id="anniversary-type-tab"
            onClick={() => setTaskType("anniversary")}
            active={taskType === "anniversary"}
          >
            Work Anniversaries
          </TaskTypeTab>
          <TaskTypeTab
            id="birthday-type-tab"
            onClick={() => setTaskType("birthday")}
            active={taskType === "birthday"}
          >
            {"Birthdays"}
          </TaskTypeTab>
        </TaskTypeCard>

        <Divider  isMargin={"10px 0px"}></Divider>
        <TableHeader id="table-header">
          <Column id="employee">Employees</Column>
          <Column id="date">{tabType === "overdue" ? "Due Date" : "Date"}</Column>
          <Column id="reminder">Reminder</Column>
          <Column id="action">
            {tabType === "completed" ? "Completed Action" : "Action"}
          </Column>
        </TableHeader>
        <ScrollableContainer id="scrollbale-container" showAllRows={showAllRows} height="380px">
          {renderTableRows()}
          {filteredData.length > 5 && !showAllRows && (
            <ShowMore id="show-more" onClick={() => setShowAllRows(true)}>Show More</ShowMore>
          )}
        </ScrollableContainer>

        {/* {filteredData.length > 5 && !showAllRows && (
          <ShowMore
            onClick={() => setShowAllRows(true)}
          >
            Show More
          </ShowMore>
        )} */}
      </MyTaskCard>
    </div>
  );
}

MyTasksCard.propTypes = {
  fetchRecognitionData: PropTypes.func,
  companyId:PropTypes.number,
};

export default MyTasksCard;
